import { p as promiseResolve, b as bootstrapLazy } from './index-fdcaa348.js';

/*
 Stencil Client Patch Esm v2.16.1 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["ap-icon_3",[[0,"ap-icon",{"icon":[1],"iconSize":[1,"icon-size"],"refresh":[64]}],[1,"ap-illustration",{"type":[1025],"width":[1],"height":[1],"register":[64]}],[0,"ap-svg-sprite",{"name":[1],"src":[1]}]]],["ap-resolution-guard",[[1,"ap-resolution-guard",{"resolutionProfiles":[32],"addProfile":[64],"removeProfile":[64]}]]]], options);
  });
};

export { defineCustomElements };
